$( () => {
  let mediaElements = $( '#social-medias figure' );
  if ( mediaElements ) {
    mediaElements.each( ( i, el ) => {
      if ( !$( el ).children( 'a' ).length ) {
        $( el ).hide();
      }
    } );
  }
} );
